import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from "axios";

/* ===== Axios base (cookie/session) ===== */
axios.defaults.headers.common["Accept"] = "application/json";

/* ===================== Styles (same base) ===================== */
const Page = styled.div`max-width: 1100px; margin: 24px auto; padding: 0 16px 28px;`;
const H1 = styled.h1`font-size: 22px; font-weight: 900; margin: 0 0 16px;`;
const Grid = styled.div`
  display: grid; gap: 16px; grid-template-columns: 2fr 1fr;
  @media (max-width: 1000px){ grid-template-columns: 1fr; }
`;
const Card = styled.div`
  background: #fff; border: 1px solid rgba(0,0,0,.08);
  border-radius: 14px; box-shadow: 0 10px 30px rgba(0,0,0,.06);
  padding: 16px 16px 18px;
`;
const CardTitle = styled.h2`
  font-size: 16px; font-weight: 900; margin: 2px 0 10px;
  display: flex; align-items:center; gap: 8px;
  &:before{
    content:''; width: 10px; height:10px; border-radius:999px; background:#0ea5e9;
    box-shadow: 0 0 0 3px rgba(14,165,233,.2);
  }
`;
const Form = styled.form`display: grid; gap: 12px;`;
const Row = styled.div`
  display: grid; gap: 10px; grid-template-columns: 1fr 1fr;
  @media (max-width: 700px){ grid-template-columns: 1fr; }
`;
const Label = styled.label`
  font-size: 12px; font-weight: 800; color: #111827; display: grid; gap: 6px;
`;
const Input = styled.input`
  height: 40px; padding: 0 12px; border-radius: 10px;
  border: 1px solid #e5e7eb; font-size: 14px; outline: none;
  &:focus { border-color: #0ea5e9; box-shadow: 0 0 0 3px rgba(14,165,233,.15); }
`;
const Select = styled.select`
  height: 40px; padding: 0 12px; border-radius: 10px;
  border: 1px solid #e5e7eb; font-size: 14px; outline: none; background:#fff;
  &:focus { border-color: #0ea5e9; box-shadow: 0 0 0 3px rgba(14,165,233,.15); }
`;
const Textarea = styled.textarea`
  min-height: 90px; padding: 10px 12px; border-radius: 10px; resize: vertical;
  border: 1px solid #e5e7eb; font-size: 14px; outline: none;
  &:focus { border-color: #0ea5e9; box-shadow: 0 0 0 3px rgba(14,165,233,.15); }
`;
const Button = styled.button`
  height: 42px; padding: 0 16px; font-size: 14px; font-weight: 900; cursor: pointer;
  border-radius: 12px; border: 1px solid rgba(0,0,0,.08); background:#111827; color:#fff;
  box-shadow: 0 10px 30px rgba(0,0,0,.08);
  transition: transform .15s ease, filter .15s ease;
  &:hover { transform: translateY(-1px); filter: brightness(.98); }
  &:disabled { opacity: .55; cursor: default; transform:none; }
`;
const Danger = styled.button`
  height: 36px; padding: 0 12px; font-size: 12px; font-weight: 800; cursor: pointer;
  border-radius: 10px; border: 1px solid #fca5a5; background:#fee2e2; color:#991b1b;
`;
const Ghost = styled.button`
  height: 36px; padding: 0 12px; font-size: 12px; font-weight: 800; cursor: pointer;
  border-radius: 10px; border: 1px solid #e5e7eb; background:#f7f7f8; color:#111827;
`;
const ImagesWrap = styled.div`display: flex; gap: 10px; flex-wrap: wrap;`;
const Thumb = styled.div`
  width: 92px; height: 92px; border-radius: 10px; border: 1px solid #e5e7eb; overflow: hidden;
  position: relative; background:#f7f7f8;
  img{ width:100%; height:100%; object-fit: cover; display:block; }
  .x{ position: absolute; top: 6px; right:6px; height: 26px; width:26px;
    display:grid; place-items:center; border-radius:999px; background:#111827; color:#fff; font-weight:900;
    border:1px solid rgba(255,255,255,.6); cursor:pointer; }
`;
const MlRow = styled.div`
  display: grid; gap: 8px; grid-template-columns: .7fr .7fr .7fr 1.4fr auto; align-items: center;
  @media (max-width: 900px){ grid-template-columns: 1fr 1fr 1fr 1fr auto; }
  @media (max-width: 700px){ grid-template-columns: 1fr; }
`;
const Small = styled.small`color:#6b7280;`;
const SectionTitle = styled.div`font-size:13px; font-weight:900; color:#111827; margin-top:4px;`;

/* Modal */
const ModalOverlay = styled.div`
  position: fixed; inset:0; z-index: 2000; background: rgba(0,0,0,.5);
  display:grid; place-items:center; -webkit-overflow-scrolling: touch; overflow:auto;
`;
const ModalCard = styled.div`
  width: min(560px, 92%); background:#fff; border:1px solid rgba(0,0,0,.08);
  border-radius: 16px; box-shadow: 0 16px 50px rgba(0,0,0,.2); padding: 16px;
`;
const ModalHead = styled.div`
  display:flex; align-items:center; justify-content:space-between; margin-bottom:8px;
  h3{ margin:0; font-size:16px; font-weight:900; }
`;
const List = styled.ul`
  margin:0; padding:0; list-style:none; max-height: 360px; overflow:auto;
  border:1px solid #e5e7eb; border-radius: 12px;
`;
const Item = styled.li`
  padding:10px 12px; border-bottom:1px solid #f1f5f9; cursor:pointer;
  &:last-child{ border-bottom:none } &:hover{ background:#f8fafc; }
`;
const AB = styled.div`
  display:flex; flex-wrap:wrap; gap:6px; margin-bottom:10px;
  button{ ${Ghost} }
`;

/* ===================== Accessories colors ===================== */
const COLOR_OPTIONS = [
  { ka:'შავი', en:'Black', hex:'#000000' },
  { ka:'თეთრი', en:'White', hex:'#FFFFFF' },
  { ka:'ლურჯი', en:'Blue', hex:'#1D4ED8' },
  { ka:'მუქი ლურჯი', en:'Navy', hex:'#0B1B34' },
  { ka:'წითელი', en:'Red', hex:'#DC2626' },
  { ka:'მწვანე', en:'Green', hex:'#16A34A' },
  { ka:'ყვითელი', en:'Yellow', hex:'#F59E0B' },
  { ka:'ვარდისფერი', en:'Pink', hex:'#EC4899' },
  { ka:'იისფერი', en:'Purple', hex:'#8B5CF6' },
  { ka:'ნარინჯისფერი', en:'Orange', hex:'#F97316' },
  { ka:'ყავისფერი', en:'Brown', hex:'#6B4423' },
  { ka:'ნიუდი', en:'Nude', hex:'#E3C6A8' },
  { ka:'ვერცხლისფერი', en:'Silver', hex:'#C0C0C0' },
  { ka:'ოქროსფერი', en:'Gold', hex:'#D4AF37' },
  { ka:'ნაცრისფერი', en:'Gray', hex:'#6B7280' },
];

const SIZES = [
  { key:'small',   label:'Small'   },
  { key:'regular', label:'Regular' },
  { key:'large',   label:'Large'   },
];

/* ===================== Component ===================== */
const AddProduct = () => {
  const [perfume, setPerfume] = useState({
    name: '', name_en: '', sex: 'woman', category: 'perfume', brand: '',
    concentration_en: '', aroma_en: '',
    description: '', description_en: '', note: '', note_en: '',
    subcategory: '', color: '', color_en: '', use: '', use_en: '',
    material: '', material_en: '', price_p: '',
    ingredients: "", ingredients_en: "", method_of_use: "", method_of_use_en: "",
    purpose_problem: "", purpose_problem_en: "", product_type: "", product_type_en: "",
    skin_type: "", skin_type_en: "",
  });

  const [images, setImages] = useState([]);               // product-level files
  const [milliliters, setMilliliters] = useState([]);     // [{size, price, unit_stock, imageFiles[]}]
  const [fullStock, setFullStock] = useState(0);          // perfume only

  // Accessories variants (colors → per-color images + sizes)
  const [accColors, setAccColors] = useState([]); // [{ka,en,hex, files:[], sizes:{small:{price,stock},regular:{...},large:{...}}}]

  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("");
  const [showBrandModal, setShowBrandModal] = useState(false);

  const isPerfume = perfume.category === 'perfume';
  const isUnitsCategory = ['skin-care','hair-and-body-care','atomizers'].includes(perfume.category);
  const isMlCategory = isPerfume || isUnitsCategory;
  const isAccessories = perfume.category === 'accessories';
const [productPickerKey, setProductPickerKey] = useState(0);
const bump = setter => setter(k => k + 1);
// Brand modal modes
const [brandMode, setBrandMode] = useState('list'); // 'list' | 'manual'
const [manualBrand, setManualBrand] = useState('');

  const API_BASE_URL = "https://admin.shopaholics.ge/api";

  /* ---------- Handlers ---------- */
// ------- Helper: format rich error for alert -------

const capFirst = (s) => {
  const t = String(s || "").trim();
  return t ? t[0].toUpperCase() + t.slice(1) : "";
};

const formatAxiosError = (err) => {
  try {
    const status = err?.response?.status;
    const statusText = err?.response?.statusText;
    const data = err?.response?.data;
    const url = err?.config?.url;
    const method = err?.config?.method?.toUpperCase?.();

    // server json (our PHP)
    if (data && typeof data === 'object') {
      const lines = [];
      if (data.error) lines.push(`error: ${data.error}`);
      if (data.detail) lines.push(`detail: ${data.detail}`);
      if (data.sqlstate) lines.push(`sqlstate: ${data.sqlstate}`);
      if (data.payload_sample) {
        lines.push(`payload_sample: ${JSON.stringify(data.payload_sample, null, 2)}`);
      }
      return [
        `HTTP ${status || ''} ${statusText || ''} — ${method || ''} ${url || ''}`,
        ...lines
      ].join('\n');
    }

    // non-JSON / empty body
    return [
      `HTTP ${status || ''} ${statusText || ''} — ${method || ''} ${url || ''}`,
      'Response body (raw):',
      typeof data === 'string' ? data : JSON.stringify(data)
    ].join('\n');
  } catch (e) {
    return `Unexpected error: ${String(err)}`;
  }
};

  // PRODUCT gallery
  const handleImageChange = (e) => {
    const selected = Array.from(e.target.files || []);
    setImages(prev => [...prev, ...selected]);
    e.target.value = ''; // allow re-choose same files later
  };
  const deleteProductImage = (idx) => setImages(prev => prev.filter((_,i)=>i!==idx));

  // ML images: append + delete

  // Accessories color images: append + delete
const onColorFilesAdd = (ka, fileList) => {
  setAccColors(prev =>
    prev.map(c => c.ka === ka
      ? { ...c, files:[...(c.files||[]), ...Array.from(fileList||[])], pickerKey:(c.pickerKey||0)+1 }
      : c
    )
  );
};
const deleteColorImage = (ka, imgIdx) => {
  setAccColors(prev =>
    prev.map(c => c.ka === ka
      ? { ...c, files:(c.files||[]).filter((_,i)=>i!==imgIdx), pickerKey:(c.pickerKey||0)+1 }
      : c
    )
  );
};

  // Basic fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPerfume(prev => ({ ...prev, [name]: value }));
  };
  const handleSub = (e) => {
    const { name, value } = e.target;
    setPerfume(prev => ({ ...prev, [name]: value }));
    if (name === 'category') {
      setPerfume(prev => ({ ...prev, subcategory: '' }));
      if (value !== 'perfume') setFullStock(0);
      setMilliliters([]);
      setAccColors([]); // reset accessories set
    }
  };

  // perfume stock
  const handleFullStockChange = (e) => {
    const v = parseInt(e.target.value || '0', 10);
    setFullStock(v);
  };

  // ML rows (perfume/care/atomizers)
// row state-ში დაამატე pickerKey
 const handleAddMilliliter = () => {
   setMilliliters(prev => [
     ...prev,
     { size:'', price:'', unit_stock:'', stock_mode:'auto', imageFiles:[], pickerKey: 0 }
   ]);
 };
const handleMlImagesAdd = (index, fileList) => {
  setMilliliters(prev => {
    const copy = [...prev];
    copy[index].imageFiles = [...(copy[index].imageFiles || []), ...Array.from(fileList || [])];
    copy[index].pickerKey = (copy[index].pickerKey || 0) + 1; // 🔁 rerender input
    return copy;
  });
};
const deleteMlImage = (index, imgIdx) => {
  setMilliliters(prev => {
    const copy = [...prev];
    copy[index].imageFiles = (copy[index].imageFiles || []).filter((_, i) => i !== imgIdx);
    copy[index].pickerKey = (copy[index].pickerKey || 0) + 1; // 🔁
    return copy;
  });
};
  const handleDeleteMilliliter = (index) => setMilliliters(prev => prev.filter((_,i)=> i!==index));
  const handleMlChange = (index, field, value) => {
    setMilliliters(prev => {
      const copy = [...prev];
      copy[index][field] = value;
     if (isPerfume && field === 'size' && (copy[index].stock_mode ?? 'auto') === 'auto') {
        const ml = parseFloat(value);
        copy[index].unit_stock = (Number.isFinite(ml) && ml > 0 && fullStock>0)
          ? Math.floor(fullStock / ml)
          : '';
      }
      return copy;
    });
  };

  // Accessories: add color
  const addColor = (ka) => {
    const opt = COLOR_OPTIONS.find(c => c.ka === ka);
    if (!opt) return;
    if (accColors.some(c => c.ka === ka)) return; // avoid duplicates
setAccColors(prev => [...prev, {
  ka: opt.ka, en: opt.en, hex: opt.hex,
  files: [], pickerKey: 0,
  sizes: { small:{price:'',stock:''}, regular:{price:'',stock:''}, large:{price:'',stock:''} }
}]);
  };
  const removeColor = (ka) => setAccColors(prev => prev.filter(c => c.ka !== ka));
  const onColorSizeChange = (ka, sizeKey, field, value) => {
    setAccColors(prev => prev.map(c => {
      if (c.ka !== ka) return c;
      return { ...c, sizes: { ...c.sizes, [sizeKey]: { ...c.sizes[sizeKey], [field]: value } } };
    }));
  };

  /* ---------- Upload helper ---------- */
async function uploadImages(files){
  const arr = Array.from(files || []);
  if (arr.length === 0) return [];

  const fd = new FormData();
  // ✅ ბევრი PHP სკრიპტი ელოდება 'images[]'
  arr.forEach(f => fd.append('images[]', f, f.name));

  const r = await axios.post(`${API_BASE_URL}/upload_images.php`, fd, {
    withCredentials: false,
    // ❗️არ უნდა დავუყენოთ Content-Type ხელით — ბრაუზერი ჩასვამს boundary-ს
    headers: { Accept: 'application/json' },
    validateStatus: () => true,
  });

  if (r.status < 200 || r.status >= 300) throw new Error(`Upload HTTP ${r.status}`);
  if (r?.data?.error) throw new Error(String(r.data.error));
  // სერვერი უნდა აბრუნებდეს მასივს imageUrls — ყველა ატვირთული ფაილი
  return Array.isArray(r.data?.imageUrls) ? r.data.imageUrls : [];
}

  /* ---------- Submit ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // product gallery
      const productImageUrls = await uploadImages(images);

      // per-ML images (NOTICE: we DO NOT send stock_strategy; backend decides by category)
      const mlWithImages = [];
      for (let i=0; i<milliliters.length; i++){
        const row = milliliters[i];
                if ((row.size ?? '') === '' && (row.price ?? '') === '' && (row.unit_stock ?? '') === '' && (!row.imageFiles || row.imageFiles.length===0)) {
          continue;
        }

        const urls = await uploadImages(row.imageFiles || []);
        if (!urls.length && (row.imageFiles?.length || 0) > 0) {
          alert("ML სურათების ატვირთვა ვერ მოხერხდა (imageUrls ცარიელია)");
        }
 const mode = (row.stock_mode ?? 'auto');
 mlWithImages.push({
   size: row.size === '' ? null : Number(row.size),
   price: row.price === '' ? 0 : Number(row.price),
   // პარფიუმერია: auto ⇒ unit_stock=null; units ⇒ გაგზავნე რიცხვი
   unit_stock: isPerfume
     ? (mode === 'auto' ? null : Number(row.unit_stock || 0))
     : Number(row.unit_stock || 0),
   stock_mode: isPerfume ? mode : 'units',
   imageUrls: urls
 });
      }

      // accessories variants → flatten sizes
      const accessories_variants = [];
      if (isAccessories && accColors.length){
        for (const c of accColors){
          const colorImageUrls = await uploadImages(c.files || []);
          for (const s of SIZES){
            const pr = c.sizes[s.key].price;
            const st = c.sizes[s.key].stock;
            if (pr === '' && st === '') continue;
            accessories_variants.push({
              color_ka: c.ka,
              color_en: c.en,
              color_hex: c.hex,
              size_label: s.key,
              price: pr === '' ? null : Number(pr),
              stock: st === '' ? 0 : parseInt(st,10),
              imageUrls: colorImageUrls
            });
          }
        }
      }

      const payload = {
        // base
        name: perfume.name, name_en: perfume.name_en, sex: perfume.sex,
        category: perfume.category, brand: capFirst(perfume.brand),
        description: perfume.description, description_en: perfume.description_en,
        note: perfume.note, note_en: perfume.note_en,

        // perfume only
        fullStock: isPerfume ? Number(fullStock || 0) : null,
        concentration_en: perfume.concentration_en || null,
        aroma_en: perfume.aroma_en || null,

        // accessories only (product-level info)
        subcategory: perfume.subcategory || null,
        color: perfume.color || null,
        color_en: perfume.color_en || null,
        use: perfume.use || null, use_en: perfume.use_en || null,
        material: perfume.material || null, material_en: perfume.material_en || null,
        price_p: perfume.price_p || null,

        // care/hair
        ingredients: perfume.ingredients || null, ingredients_en: perfume.ingredients_en || null,
        method_of_use: perfume.method_of_use || null, method_of_use_en: perfume.method_of_use_en || null,
        purpose_problem: perfume.purpose_problem || null, purpose_problem_en: perfume.purpose_problem_en || null,
        product_type: perfume.product_type || null, product_type_en: perfume.product_type_en || null,
        skin_type: perfume.skin_type || null, skin_type_en: perfume.skin_type_en || null,

        // galleries
        imageUrls: productImageUrls,
        milliliters: mlWithImages,

        // accessories variants
        accessories_variants,

        email: JSON.parse(localStorage.getItem("user"))?.email || null
      };

 const res = await axios.post(`${API_BASE_URL}/add_perfume.php?debug=1`, payload, {
   withCredentials: true,
   headers: { "Content-Type": "application/json", Accept: "application/json" },
 });

      if (res?.data?.error) {
        alert(`Server said error:\n${JSON.stringify(res.data, null, 2)}`);
        return;
      }
      if (res?.status !== 200) {
        alert(`Unexpected HTTP status: ${res?.status}\n${JSON.stringify(res?.data, null, 2)}`);
        return;
      }
      alert(res.data?.message || 'Saved');
    } catch (err) {
      console.error(err);
      alert(`Save failed:\n${formatAxiosError(err)}`);
    }
  };

  /* ---------- Brands Modal ---------- */
  const openBrandModal = () => setShowBrandModal(true);
  const closeBrandModal = () => {
    setShowBrandModal(false);
    setSearchQuery(''); setSelectedLetter(''); setFilteredBrands(brands);
  };
  useEffect(() => {
    const filtered = brands.filter(
      b => b.name.toLowerCase().includes(searchQuery.toLowerCase())
           && (selectedLetter==='' || b.name.toUpperCase().startsWith(selectedLetter))
    );
    setFilteredBrands(filtered);
  }, [searchQuery, selectedLetter, brands]);
const selectBrand = (name) => {
  setPerfume(prev => ({...prev, brand: capFirst(name)}));
  closeBrandModal();
};

useEffect(() => {
  (async () => {
    try {
      const [rBrands, rProducts] = await Promise.all([
        axios.get(`${API_BASE_URL}/get_brands.php`, { withCredentials: true, validateStatus: () => true }),
        axios.get(`${API_BASE_URL}/product_list.php`, { withCredentials: true, validateStatus: () => true }),
      ]);

      const apiNames = Array.isArray(rBrands.data) ? rBrands.data.map(b => b.name).filter(Boolean) : [];
      const prodArr  = Array.isArray(rProducts.data) ? rProducts.data : [];
      const prodNames = prodArr.map(p => p?.brand).filter(Boolean);

      // join + dedupe case-insensitively, keep CapFirst for display
      const map = new Map();
      [...apiNames, ...prodNames].forEach(n => {
        const v = capFirst(n);
        if (!map.has(v.toLowerCase())) map.set(v.toLowerCase(), v);
      });

      const final = Array.from(map.values())
        .sort((a,b)=>a.localeCompare(b))
        .map((name, i) => ({ id: `b-${i}`, name }));

      setBrands(final);
      setFilteredBrands(final);
    } catch (e) {
      console.error("brands union load failed", e);
      setBrands([]); setFilteredBrands([]);
    }
  })();
}, []);

  return (
    <Page>
      <H1>პროდუქტის დამატება</H1>

      <Grid>
        {/* LEFT - Main form */}
        <Card>
          <CardTitle>ძირითადი ინფორმაცია</CardTitle>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Label>დასახელება
                <Input name="name" value={perfume.name} onChange={handleChange} />
              </Label>
              <Label>დასახელება (EN)
                <Input name="name_en" value={perfume.name_en} onChange={handleChange} />
              </Label>
            </Row>

            <Row>
              <Label>სქესი
                <Select name="sex" value={perfume.sex} onChange={handleChange}>
                  <option value="woman">Woman</option>
                  <option value="man">Man</option>
                  <option value="kids">Kids</option>
                  <option value="unisex">Unisex</option>
                </Select>
              </Label>

              <Label>კატეგორია
                <Select name="category" value={perfume.category} onChange={handleSub}>
                  <option value="perfume">Perfume</option>
                  <option value="skin-care">Skin Care</option>
                  <option value="hair-and-body-care">Hair and Body Care</option>
                  <option value="atomizers">Atomizers</option>
                  <option value="accessories">Accessories</option>
                </Select>
              </Label>
            </Row>

            {perfume.category === 'accessories' && (
              <Row>
                <Label>აქსესუარის ტიპი
                  <Select name="subcategory" value={perfume.subcategory} onChange={handleChange}>
                    <option value="">აირჩიეთ</option>
                    <option value="sunglasses">Sunglasses</option>
                    <option value="bags">Bags</option>
                  </Select>
                </Label>
                <div />
              </Row>
            )}

            <Row>
<Label>ბრენდი
  <Input
    name="brand"
    list="brandsList"
    value={perfume.brand}
    onChange={handleChange}
    placeholder="შეიყვანე ან აირჩიე სიიდან"
  />
  {/* suggestions datalist არსებული ბრენდებიდან */}
  <datalist id="brandsList">
    {brands.map(b => (
      <option key={b.id ?? b.name} value={b.name} />
    ))}
  </datalist>

  <Small style={{marginTop:4}}>
    თუ გირჩევნია ბრაუზინგი/ფილტრი:{" "}
    <Ghost type="button" onClick={() => { setManualBrand(perfume.brand || ""); setBrandMode('list'); openBrandModal(); }}>
      Existing brands…
    </Ghost>
  </Small>
</Label>
              {isPerfume && (
                <Label>Full stock (ml) — პარფიუმერია
                  <Input type="number" value={fullStock} onChange={handleFullStockChange} />
                </Label>
              )}
            </Row>

            {isPerfume && (
              <Row>
                <Label>Concentration (EN)
                  <Input name="concentration_en" value={perfume.concentration_en} onChange={handleChange} />
                </Label>
                <Label>Aromas (EN)
                  <Input name="aroma_en" value={perfume.aroma_en} onChange={handleChange} />
                </Label>
              </Row>
            )}

            {/* Accessories extra */}
            {isAccessories && (
              <>
                <Row>
                  <Label>Material
                    <Input name="material" value={perfume.material} onChange={handleChange} />
                  </Label>
                  <Label>Material (EN)
                    <Input name="material_en" value={perfume.material_en} onChange={handleChange} />
                  </Label>
                </Row>
                <Row>
                  <Label>Use
                    <Textarea name="use" value={perfume.use} onChange={handleChange} />
                  </Label>
                  <Label>Use (EN)
                    <Textarea name="use_en" value={perfume.use_en} onChange={handleChange} />
                  </Label>
                </Row>
                <Row>
                  <Label>Price (optional, if no per-variant price)
                    <Input type="number" name="price_p" step="0.01" value={perfume.price_p} onChange={handleChange} />
                  </Label>
                </Row>
              </>
            )}

            <CardTitle>აღწერა და მახასიათებლები</CardTitle>
            <Row>
              <Label>აღწერა
                <Textarea name="description" value={perfume.description} onChange={handleChange} />
              </Label>
              <Label>აღწერა (EN)
                <Textarea name="description_en" value={perfume.description_en} onChange={handleChange} />
              </Label>
            </Row>

            <Row>
              <Label>შენიშვნა
                <Textarea name="note" value={perfume.note} onChange={handleChange} />
              </Label>
              <Label>შენიშვნა (EN)
                <Textarea name="note_en" value={perfume.note_en} onChange={handleChange} />
              </Label>
            </Row>

            {(perfume.category === 'skin-care' || perfume.category === 'hair-and-body-care') && (
              <>
                <Row>
                  <Label>ინგრედიენტები
                    <Textarea name="ingredients" value={perfume.ingredients} onChange={handleChange} />
                  </Label>
                  <Label>ინგრედიენტები (EN)
                    <Textarea name="ingredients_en" value={perfume.ingredients_en} onChange={handleChange} />
                  </Label>
                </Row>
                <Row>
                  <Label>გამოყენების წესი
                    <Textarea name="method_of_use" value={perfume.method_of_use} onChange={handleChange} />
                  </Label>
                  <Label>გამოყენების წესი (EN)
                    <Textarea name="method_of_use_en" value={perfume.method_of_use_en} onChange={handleChange} />
                  </Label>
                </Row>
                <Row>
                  <Label>დანიშნულება / პრობლემა
                    <Textarea name="purpose_problem" value={perfume.purpose_problem} onChange={handleChange} />
                  </Label>
                  <Label>დანიშნულება / პრობლემა (EN)
                    <Textarea name="purpose_problem_en" value={perfume.purpose_problem_en} onChange={handleChange} />
                  </Label>
                </Row>
                <Row>
                  <Label>პროდუქტის ტიპი
                    <Input name="product_type" value={perfume.product_type} onChange={handleChange} />
                  </Label>
                  <Label>პროდუქტის ტიპი (EN)
                    <Input name="product_type_en" value={perfume.product_type_en} onChange={handleChange} />
                  </Label>
                </Row>
                <Row>
                  <Label>კანის ტიპი
                    <Input name="skin_type" value={perfume.skin_type} onChange={handleChange} />
                  </Label>
                  <Label>კანის ტიპი (EN)
                    <Input name="skin_type_en" value={perfume.skin_type_en} onChange={handleChange} />
                  </Label>
                </Row>
              </>
            )}

            {/* ML rows */}
            {isMlCategory && (
              <>
                <CardTitle>მილილიტრები</CardTitle>
                <Small>
                  {isPerfume
                    ? 'Perfume: მარაგი ითვლება Full stock-იდან ავტომატურად.'
                    : 'Care/Atomizers: მიუწერე ერთეულების მარაგი თითო ML-ზე (unit stock).'}
                </Small>

                {milliliters.map((ml, idx) => (
                  <MlRow key={idx}>
                    <Input
                      type="number" placeholder="Size (ml)"
                      value={ml.size}
                      onChange={(e)=>handleMlChange(idx,'size',e.target.value)}
                    />
                    <Input
                      type="number" placeholder="Price"
                      value={ml.price}
                      onChange={(e)=>handleMlChange(idx,'price',e.target.value)}
                    />
     {isPerfume ? (
       <>
         <Select
           value={ml.stock_mode ?? 'auto'}
           onChange={(e)=>{
             const mode = e.target.value;
             setMilliliters(prev=>{
               const copy=[...prev];
               copy[idx].stock_mode = mode;
               // თუ გადავედით 'auto'-ზე — თავიდან დაითვალოს
               if (mode === 'auto') {
                 const mlv = parseFloat(copy[idx].size);
                 copy[idx].unit_stock = (Number.isFinite(mlv) && mlv>0 && fullStock>0)
                   ? Math.floor(fullStock/mlv) : '';
               }
             return copy;
             });
           }}
         >
           <option value="auto">Auto from Full stock</option>
           <option value="units">Units per bottle</option>
         </Select>
         <Input
           type="number"
           placeholder={(ml.stock_mode ?? 'auto')==='auto' ? "Auto stock" : "Stock (units)"}
           value={ml.unit_stock}
           readOnly={(ml.stock_mode ?? 'auto')==='auto'}
           onChange={(e)=> (ml.stock_mode ?? 'auto')==='units' && handleMlChange(idx,'unit_stock',e.target.value)}
         />
       </>
     ) : (
       <Input
         type="number" placeholder="Stock (units)"
         value={ml.unit_stock}
         onChange={(e)=>handleMlChange(idx,'unit_stock',e.target.value)}
       />
     )}
                    <div>
                      <SectionTitle>Images (ML)</SectionTitle>
<Input
  key={ml.pickerKey || 0}
  type="file"
  multiple
  onChange={(e) => handleMlImagesAdd(idx, e.target.files)}
/>
                      <ImagesWrap style={{ marginTop: 8 }}>
                        {(ml.imageFiles || []).map((file, imgIdx) => (
                          <Thumb key={imgIdx}>
                            <img src={URL.createObjectURL(file)} alt={`ml-${idx}-${imgIdx}`} />
                            <div className="x" onClick={() => deleteMlImage(idx, imgIdx)}>×</div>
                          </Thumb>
                        ))}
                      </ImagesWrap>
                    </div>
                    <Danger type="button" onClick={()=>handleDeleteMilliliter(idx)}>Delete</Danger>
                  </MlRow>
                ))}
                <Ghost type="button" onClick={handleAddMilliliter}>Add More Milliliters</Ghost>
              </>
            )}

            {/* Accessories variants */}
            {isAccessories && (
              <>
                <CardTitle>აქსესუარის ვარიაციები (ფერები + ზომები)</CardTitle>
                <Small>აირჩიე ფერი (ქართულად). ინგლისური სახელწოდება ჩაიწერება ავტომატურად.</Small>

                <Row>
                  <Label>ფერის არჩევა
                    <Select onChange={(e)=>{ if(e.target.value) { addColor(e.target.value); e.target.value=''; } }}>
                      <option value="">აირჩიე ფერი…</option>
                      {COLOR_OPTIONS.map(c => (
                        <option key={c.ka} value={c.ka}>{c.ka}</option>
                      ))}
                    </Select>
                  </Label>
                  <div />
                </Row>

                {accColors.map(c => (
                  <div key={c.ka} style={{border:'1px solid #e5e7eb', borderRadius:12, padding:12, marginBottom:10}}>
                    <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8}}>
                      <div style={{display:'flex', alignItems:'center', gap:10}}>
                        <div style={{width:18, height:18, borderRadius:6, background:c.hex, border:'1px solid #e5e7eb'}} />
                        <strong>{c.ka}</strong>
                        <Small>({c.en})</Small>
                      </div>
                      <Danger type="button" onClick={()=>removeColor(c.ka)}>ფერის წაშლა</Danger>
                    </div>

                    <Row>
                      {SIZES.map(s => (
                        <div key={s.key} style={{border:'1px dashed #e5e7eb', borderRadius:10, padding:10}}>
                          <SectionTitle>{s.label}</SectionTitle>
                          <div style={{display:'grid', gap:8, gridTemplateColumns:'1fr 1fr'}}>
                            <Input
                              type="number" placeholder="Price"
                              value={c.sizes[s.key].price}
                              onChange={(e)=>onColorSizeChange(c.ka, s.key, 'price', e.target.value)}
                            />
                            <Input
                              type="number" placeholder="Stock"
                              value={c.sizes[s.key].stock}
                              onChange={(e)=>onColorSizeChange(c.ka, s.key, 'stock', e.target.value)}
                            />
                          </div>
                        </div>
                      ))}
                    </Row>

                    <div style={{ marginTop: 8 }}>
                      <SectionTitle>სურათები (ფერისთვის)</SectionTitle>
<Input
  key={c.pickerKey || 0}
  type="file"
  multiple
  onChange={(e) => onColorFilesAdd(c.ka, e.target.files)}
/>
                      <ImagesWrap style={{ marginTop: 8 }}>
                        {(c.files || []).map((file, imgIdx) => (
                          <Thumb key={imgIdx}>
                            <img src={URL.createObjectURL(file)} alt={`color-${c.ka}-${imgIdx}`} />
                            <div className="x" onClick={() => deleteColorImage(c.ka, imgIdx)}>×</div>
                          </Thumb>
                        ))}
                      </ImagesWrap>
                    </div>
                  </div>
                ))}
              </>
            )}

            <Button type="submit">შენახვა</Button>
          </Form>
        </Card>

        {/* RIGHT - Product gallery & Brand picker */}
        <Card>
          <CardTitle>Product Images (Gallery)</CardTitle>
          <Small>ეს სურათები მიებმება პროდუქტს მთლიანად. ML/Color სურათები ცალკეა.</Small>
          <div style={{marginTop:10}}>
<Input
  key={productPickerKey}
  type="file"
  multiple
  onChange={(e)=>{ handleImageChange(e); bump(setProductPickerKey); }}
/>
          </div>
          <ImagesWrap style={{marginTop:10}}>
            {images.map((file, idx) => (
              <Thumb key={idx}>
                <img src={URL.createObjectURL(file)} alt={`img-${idx}`} />
                <div className="x" onClick={()=>deleteProductImage(idx)}>×</div>
              </Thumb>
            ))}
          </ImagesWrap>
        </Card>
      </Grid>

      {showBrandModal && (
<ModalOverlay>
  <ModalCard>
    <ModalHead>
      <h3>აირჩიე ბრენდი</h3>
      <Ghost onClick={closeBrandModal}>Close</Ghost>
    </ModalHead>

    <AB style={{ marginTop: 6 }}>
      <Ghost onClick={() => setBrandMode('list')} style={{ fontWeight: brandMode==='list' ? 900 : 800 }}>
        სიიდან არჩევა
      </Ghost>
      <Ghost onClick={() => setBrandMode('manual')} style={{ fontWeight: brandMode==='manual' ? 900 : 800 }}>
        ხელით შეყვანა
      </Ghost>
    </AB>

    {brandMode === 'manual' ? (
      <div style={{ display:'grid', gap:10, marginTop:8 }}>
        <Label>ბრენდის სახელწოდება
          <Input
            value={manualBrand}
            onChange={e => setManualBrand(e.target.value)}
            placeholder="e.g. Dior, Tom Ford, ..."
          />
        </Label>
        <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
          <Ghost onClick={() => setBrandMode('list')}>უკან სიაში</Ghost>
          <Button
            type="button"
            onClick={() => { setPerfume(prev => ({ ...prev, brand: (capFirst(manualBrand) || '').trim() })); closeBrandModal(); }}
            disabled={!manualBrand.trim()}
          >
            გამოიყენე ეს სახელი
          </Button>
        </div>
      </div>
    ) : (
      <>
        <Input placeholder="Search brands..." value={searchQuery} onChange={e=>setSearchQuery(e.target.value)} />
        <AB style={{marginTop:8}}>
          {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map(ch => (
            <Ghost key={ch} onClick={()=>setSelectedLetter(ch)}>{ch}</Ghost>
          ))}
          <Ghost onClick={()=>setSelectedLetter('')}>All</Ghost>
        </AB>

        <List>
          {filteredBrands.length ? filteredBrands.map(b=>(
            <Item key={b.id} onClick={()=>selectBrand(b.name)}>{b.name}</Item>
          )) : <Item>Nothing found</Item>}
        </List>
      </>
    )}
  </ModalCard>
</ModalOverlay>

      )}
    </Page>
  );
};

export default AddProduct;
